<template>
	<el-checkbox-group v-model="checkList" @change="changeCheck">
		<el-checkbox v-for="item in myoptions" :label="item.vid" :key="item.vid">{{item.name}}</el-checkbox>
	</el-checkbox-group>
</template>

<script>
export default {
	name:'myselect',
	props:['myoptions','pid','myValue'],
	data(){
		return {
			checkList:[]
		}
	},
	watch:{
	},
	mounted(){
		if(this.myValue != "" && this.myValue != null && this.myValue.length>0){
			this.checkList = this.myValue;
		}
	},
	methods:{
		changeCheck(){
			this.$emit("changeCheck",this.pid,this.checkList);
		}
	}
}
</script>

<style>
</style>